module.exports = __webpack_public_path__ + "static/media/disabledVehicleIcon.6d1020ee.svg";